import React from "react";
import { Modal, Button, Row, Col, Form } from "react-bootstrap";
import key from "../../lib/config";
import { toast } from "react-toastify";

const TicketModal = ({
  show,
  fileDownloader,
  updateData,
  setreplay,
  replay,
  handleClose,
  replaySupportTicket,
  disableStatus=false,
}) => {
  return (
    <div>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title className="t-primary">Queries</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="modalbox">
            <p className="t-grey mb-3 text-uppercase">View Ticket Details</p>
            <Row>
              <Col xs={12} sm={12} md={6} className="mb-3">
                <Form.Group>
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    value={updateData?.userEmail ?? ""}
                    type="text"
                  />
                </Form.Group>
              </Col>
              <Col xs={12} sm={12} md={6} className="mb-3">
                <Form.Group>
                  <Form.Label>Subject</Form.Label>
                  <Form.Control value={updateData?.subject ?? ""} type="text" />
                </Form.Group>
              </Col>
              <Col xs={12} sm={12} md={12} className="mb-3">
                <Form.Group>
                  <Form.Label>Description</Form.Label>
                  <Form.Control
                    value={updateData?.description ?? ""}
                    rows={6}
                    as={"textarea"}
                  />
                </Form.Group>
              </Col>
              <Col xs={12} sm={12} md={6} className="mb-3">
                <Form.Group className="d-flex align-items-center gap-3">
                  <p className="t-primary">Query Image</p>
                  <button
                    type="button"
                    onClick={() => {
                      updateData?.attachment != ""
                        ? fileDownloader(
                            `${key.Back_Url}/support/${updateData?.attachment}`
                          )
                        : toast.error("Attachment is not available");
                    }}
                    className="btn sitebtn py-2 px-3"
                  >
                    Download
                  </button>
                </Form.Group>
              </Col>
              <Col xs={12} sm={12} md={12} className="mb-3 mt-3">
                <p className="t-grey mb-3 text-uppercase">Reply to Ticket</p>
                <Form.Group>
                  <Form.Label>Message</Form.Label>
                  <Form.Control
                    placeholder="Enter Message"
                    value={replay}
                    onChange={(e) => {
                      setreplay(e.target.value);
                    }}
                    rows={6}
                    as={"textarea"}
                  />
                </Form.Group>
              </Col>
            </Row>
            <button
              type="button"
              onClick={() => {
                replaySupportTicket();
              }}
              className="btn sitebtn px-3 py-2"
              disabled={disableStatus}
            >
              Reply
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default TicketModal;
